<template>
    <div v-if="loaded" id="gl1" class="glide bng-casino-home-banner">
        <div data-glide-el="track" class="glide__track">
            <ul class="glide__slides">
                <!-- <li class="glide__slide">
                    <fish-banner />
                </li> -->
                <li v-if="theme == 'luckerhub'" class="glide__slide">
                    <races-banner />
                </li>
                <li v-if="theme == 'luckerhub'" class="glide__slide">
                    <crash-games-banner />
                </li>
                <li v-if="theme == 'luckerhub'" class="glide__slide">
                    <fast-games-banner />
                </li>
                <!-- <li v-if="isSportActive" class="glide__slide">
                    <sport-banner />
                </li>
                <li v-if="isLiveGamesActive" class="glide__slide">
                    <new-live-games-banner />
                </li>
                <li v-if="isDepositBonusActive" class="glide__slide">
                    <deposit-bonus-banner />
                </li>
                <li v-if="isRegistrationBonusActive" class="glide__slide">
                    <registration-bonus-banner />
                </li>
                <li v-if="isCashbackBonusActive" class="glide__slide">
                    <cashback-bonus-banner />
                </li> -->
            </ul>
        </div>
        <div v-if="slidesCount > 1" data-glide-el="controls[nav]" class="glide__controls">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<"></button>
            <div class="glide__bullets" data-glide-el="controls[nav]">
                <button v-for="i in slidesCount" :key="i" class="glide__bullet" :data-glide-dir="`=${i-1}`"></button>
            </div>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">"></button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import Glide from '@glidejs/glide';

import FishBanner from './fish.vue';
import SportBanner from './sport.vue';
import NewLiveGamesBanner from './new-live-games.vue';
import RacesBanner from './races.vue';
import CrashGamesBanner from './crash-games.vue';
import FastGamesBanner from './fast-games.vue';
import DepositBonusBanner from './deposit-bonus.vue';
import RegistrationBonusBanner from './registration-bonus.vue';
import CashbackBonusBanner from './cashback-bonus.vue';

export default {
    name: 'casino-home-banner',
    components: {
        FishBanner,
        SportBanner,
        NewLiveGamesBanner,
        DepositBonusBanner,
        RegistrationBonusBanner,
        CashbackBonusBanner,
        RacesBanner,
        CrashGamesBanner,
        FastGamesBanner
    },
    props: {
        elemId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            loaded: false,
            isLiveGamesActive: false,
            isDepositBonusActive: false,
            isRegistrationBonusActive: false,
            isCashbackBonusActive: false,
            slidesCount: 0,
            theme: null
        };
    },
    async created() {
        await Vue.state.games.ensure();
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();

        this.theme = (client && client.view && client.view.style.theme) || 'dark';

        this.isSportActive = Vue.state.games.get().categories.find(c => c.name == 'sport');
        this.isLiveGamesActive = Vue.state.games.get().categories.find(c => c.name == 'video-games');
        this.isDepositBonusActive = client.bonus && client.bonus.deposit;
        this.isRegistrationBonusActive = client.bonus && client.bonus.registration;
        this.isCashbackBonusActive = client.bonus && client.bonus.cashback;

        // this.slidesCount++; // fish

        if(this.theme == 'luckerhub'){
            this.slidesCount++; // races
            this.slidesCount++; // crash-games
            this.slidesCount++; // fast-games
        }
        
        // if (this.isSportActive) this.slidesCount++;
        // if (this.isLiveGamesActive) this.slidesCount++;
        // if (this.isDepositBonusActive) this.slidesCount++;
        // if (this.isRegistrationBonusActive) this.slidesCount++;
        // if (this.isCashbackBonusActive) this.slidesCount++;

        this.loaded = true;

        setTimeout(() => {
            new Glide('#gl1', { autoplay: 3000 }).mount();
        });
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/casino-home-banner.vue